import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  skool_membership_url: "https://www.skool.com/care-placement-pro-9714",
  skool_accelerator_url: "https://www.skool.com/care-placement-pro-9714",
  membership_price: "$50/month",
  accelerator_price: "$2,500 one-time",
  logo_url: "",
  company_email_from: "Care Placement Pro Team",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || DEFAULTS;
